module.exports = __webpack_public_path__ + "static/img/70.d292491.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/70.png
// module id = fz9l
// module chunks = 1